/**
 * Listed playing time from BGG collection item (`stats=1`).
 * @param {object} game
 * @returns {number|null} minutes, or null if unknown
 */
export function getCollectionPlayingMinutes(game) {
	const v = game?.stats?.['@_playingtime']
	if (v == null || v === '') return null
	const n = Number(v)
	if (!Number.isFinite(n)) return null
	if (n <= 0) return null
	return n
}

/**
 * @param {object[]} collection
 * @param {string|null|undefined} maxMinutes — 'any' or numeric string
 */
export function filterByMaxPlayingTime(collection, maxMinutes) {
	if (maxMinutes == null || maxMinutes === 'any') return collection
	const max = Number(maxMinutes)
	if (!Number.isFinite(max) || max <= 0) return collection
	return collection.filter((game) => {
		const t = getCollectionPlayingMinutes(game)
		if (t == null) return true
		return t <= max
	})
}

export const MAX_PLAY_TIME_FILTER_OPTIONS = [
	{ value: 'any', label: 'Any' },
	{ value: '30', label: '≤ 30 min' },
	{ value: '45', label: '≤ 45 min' },
	{ value: '60', label: '≤ 60 min' },
	{ value: '90', label: '≤ 90 min' },
	{ value: '120', label: '≤ 120 min' },
	{ value: '180', label: '≤ 180 min' },
	{ value: '240', label: '≤ 240 min' },
]

/**
 * Apply max play time from `/collection` stats only (no extra BGG calls).
 * @param {object[]} playerFiltered — already player-count filtered
 * @param {{ maxPlayTime: string|null }} opts
 * @returns {{ list: object[] }}
 */
export function applyMaxPlayTimeFilter(playerFiltered, opts) {
	const maxPlay = opts.maxPlayTime != null ? String(opts.maxPlayTime) : 'any'
	const list = filterByMaxPlayingTime(playerFiltered, maxPlay)
	return { list }
}
